import React, { useState, useEffect } from "react";
import ga from "@Lib/ga";
import { host, article } from "@Api";
import Refresh from "@Components/common/Refresh";
import LazyloadImage from "./lazyLoadImage";
import { g4 } from "../../utils/helper";

const { fetchRecommendHot } = article;

const ArticlePopover: React.FC<{ isMount: boolean }> = ({ isMount }) => {
  const { c } = host;
  const [hotData, setHotData] = useState([]);
  const list = [
    { title: "新車上市", href: `${c}/news?t=18` },
    { title: "國內車訊", href: `${c}/news?t=1` },
    { title: "排行報告", href: `${c}/news?t=6` },
    { title: "國外車訊", href: `${c}/news?t=3` },
    { title: "優惠快訊", href: `${c}/news?t=2` },
    { title: "車展報告", href: `${c}/news?t=8` },
    { title: "售後資訊", href: `${c}/article/after-sale` },
    { title: "汽車趣聞", href: `${c}/news?t=17` },
    { title: "編輯精選", href: `${c}/news?t=22` },
    { title: "品牌專訪", href: `${c}/feature/4135` },
  ];

  const bgimg = [
    "https://photo.8891.com.tw/2023/09/07/1694079718946348.png",
    "https://photo.8891.com.tw/2023/09/07/1694079718942078.png",
    "https://photo.8891.com.tw/2023/09/07/1694079719098088.png",
  ];
  const Item: React.FC<{ item: any; i: number }> = ({ item, i }) => {
    return (
      <Refresh
        refresh={() => {
          g4("article_exposured", {
            page: "首頁",
            spm: "",
            channel: "文章",
            module: "頂部導航下拉框",
            element: "文章",
            element_id: item.id,
            next_spm: "2.46.85.105",
          });
        }}
      >
        <a
          href={`${item.link}${item.link.includes("?") ? "&" : "?"}spm=2.46.85.105`}
          target='_blank'
          className='flex items-center'
          onClick={() => {
            g4("article_clicked", {
              page: "首頁",
              spm: "",
              channel: "文章",
              element: "文章",
              element_id: item.id,
              module: "頂部導航下拉框",
              object_id: "",
              next_spm: "2.46.85.105",
            });
          }}
        >
          <LazyloadImage
            Loaded={isMount}
            src={bgimg[i]}
            style={{ width: "24px", height: "20px", marginRight: "14px" }}
          />
          <LazyloadImage
            Loaded={isMount}
            style={{ width: "70px", height: "46px", marginRight: "10px" }}
            src={item.thumb}
          />
          <p className='w-250 text-16 text-[#666] ellipsis-2'>{item.title}</p>
        </a>
      </Refresh>
    );
  };

  async function fetchRecommend() {
    try {
      const res = await fetchRecommendHot({ limit: 3, needSmallTitle: 1 });
      if (res && res.status === 12000) {
        setHotData(res.data.list);
      }
    } catch (e) {}
  }

  useEffect(() => {
    if (isMount) {
      fetchRecommend();
    }
  }, [isMount]);

  return (
    <div
      className='absolute pl-28 pt-20 top-56 left-0 w-full h-290 bg-[#fff] z-10000000 box-border flex nav-popover-shadow shadow-inherit max-w-[1190px] min-w-[1190px] w-[1190px]'
      style={{
        boxShadow: "2px 6px 10px rgba(0,0,0,0.10)",
      }}
    >
      <div className='relative pr-24 mr-20'>
        <h3 className='text-20 leading-20 text-[#333] font-medium mb-20'>新聞分類</h3>
        <Refresh
          refresh={() => {
            g4("article_column_exposured", {
              page: "首頁",
              spm: "",
              channel: "文章",
              module: "頂部導航下拉框",
              element: "新聞分類",
              element_id: list.map((item) => item.title).join(","),
              next_spm: "",
            });
          }}
        ></Refresh>
        <div className='flex flex-wrap w-328 pt-20 border-0 border-r-1 border-solid border-[#e8e8e8]'>
          {list.map((item, index) => (
            <a
              key={index}
              className={`w-106 text-16 text-decoration-line mb-30 text-[#333] text-center border-0 border-r-1 border-solid ${
                index % 3 === 2 || index === list.length - 1
                  ? "border-[transparent]"
                  : "border-[#e8e8e8]"
              } `}
              href={item.href}
              target='_blank'
              onClick={() => {
                g4("article_column_clicked", {
                  page: "首頁",
                  spm: "",
                  channel: "文章",
                  module: "頂部導航下拉框",
                  element: "新聞分類",
                  element_id: item.title,
                  next_spm: "",
                });
              }}
            >
              {item.title}
            </a>
          ))}
        </div>
      </div>
      <div className='relative pr-24 mr-20'>
        <h3 className='text-20 mr-0 mb-20 text-[#333] font-medium leading-20'>熱門欄目</h3>
        <Refresh
          refresh={() => {
            g4("article_column_exposured", {
              page: "首頁",
              spm: "",
              channel: "文章",
              module: "頂部導航下拉框",
              element: "熱門欄目",
              element_id: "搶先試駕、超級測試、車用品超級測試、PK比較",
              next_spm: "",
            });
          }}
        ></Refresh>
        <ul className='flex w-352 flex-wrap justify-around border-0 border-r-1 border-solid border-[#e8e8e8]'>
          <li className='w-130 mt-0 mr-24 leading-18 text-14 block'>
            <a
              href={`${c}/trialrun/?type=21`}
              className='text-[#333] text-decoration-line'
              onClick={() => {
                ga(["导航", "文章", "抢先试驾"]);
                g4("article_column_clicked", {
                  page: "首頁",
                  spm: "",
                  channel: "文章",
                  module: "頂部導航下拉框",
                  element: "熱門欄目",
                  element_id: "搶先試駕",
                  next_spm: "",
                });
              }}
              target='_blank'
            >
              <LazyloadImage
                Loaded={isMount}
                src='https://photo.8891.com.tw/2023/09/05/1693900645743975.png'
                style={{ width: "100%", height: "50px", marginBottom: "12px" }}
              />
              <p className='mb-30 text-14 leading-18 text-[#333] text-center font-black'>搶先試駕</p>
            </a>
          </li>
          <li className='w-130 mt-0 mr-24 leading-18 text-14 block'>
            <a
              href={`${c}/trialrun/?type=23&page=1`}
              className='text-[#333] text-decoration-line'
              onClick={() => {
                ga(["导航", "文章", "超级测试"]);
                g4("article_column_clicked", {
                  page: "首頁",
                  spm: "",
                  channel: "文章",
                  module: "頂部導航下拉框",
                  element: "熱門欄目",
                  element_id: "超級測試",
                  next_spm: "",
                });
              }}
              target='_blank'
            >
              <LazyloadImage
                Loaded={isMount}
                src='https://photo.8891.com.tw/2023/09/05/1693900645693390.png'
                style={{ width: "100%", height: "50px", marginBottom: "12px" }}
              />
              <p className='mb-30 text-14 leading-18 text-[#333] text-center font-black'>超級測試</p>
            </a>
          </li>
          <li className='w-130 mt-0 mr-24 leading-18 text-14 block'>
            <a
              href={`${c}/feature/4134`}
              className='text-[#333] text-decoration-line'
              onClick={() => {
                ga(["导航", "文章", "买车大补贴"]);
                g4("article_column_clicked", {
                  page: "首頁",
                  spm: "",
                  channel: "文章",
                  module: "頂部導航下拉框",
                  element: "熱門欄目",
                  element_id: "車用品超級測試",
                  next_spm: "",
                });
              }}
              target='_blank'
            >
              <LazyloadImage
                Loaded={isMount}
                src='https://photo.8891.com.tw/2023/08/30/1693359165935371.png'
                style={{ width: "100%", height: "50px", marginBottom: "12px" }}
              />
              <p className='text-14 leading-18 text-[#333] mb-8 text-center font-black'>車用品超級測試</p>
            </a>
          </li>
          <li className='w-130 mt-0 mr-24 leading-18 text-14 block'>
            <a
              href={`${c}/Guide`}
              className='text-[#333] text-decoration-line'
              onClick={() => {
                ga(["导航", "文章", "超详细图解"]);
                g4("article_column_clicked", {
                  page: "首頁",
                  spm: "",
                  channel: "文章",
                  module: "頂部導航下拉框",
                  element: "熱門欄目",
                  element_id: "PK比較",
                  next_spm: "",
                });
              }}
              target='_blank'
            >
              <LazyloadImage
                Loaded={isMount}
                src='https://photo.8891.com.tw/2023/08/29/1693308076028158.png'
                style={{ width: "100%", height: "50px", marginBottom: "12px" }}
              />
              <p className='text-14 leading-18 text-[#333] mb-8 text-center font-black'>PK比較</p>
            </a>
          </li>
        </ul>
      </div>
      <div className='relative mr-20 pr-24'>
        <div className='flex justify-between'>
          <h3 className='text-20 leading-20 text-[#333] font-medium' style={{ marginBottom: 0, marginLeft: 0 }}>
            最熱文章
          </h3>
          <a href={`${c}/Articles`} className='text-[#333] text-14 leading-20'>
            查看全部
          </a>
        </div>
        <ul className='flex flex-col mt-20'>
          {hotData.map((item: any, i) => (
            <li className='mb-30 mt-0' key={i}>
              <Item item={item} i={i} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ArticlePopover;
